import "./Paragraph_module.css";
const Paragraph_module_rslib_entry_ = {
    paragraph: "paragraph-b8HEw0",
    small: "small-YnEPwi",
    textAlignLeft: "textAlignLeft-lRg2M7",
    textAlignCenter: "textAlignCenter-XLPJ_8",
    textAlignRight: "textAlignRight-RnYWjy",
    textAlignJustify: "textAlignJustify-NXJmws"
};
export { Paragraph_module_rslib_entry_ as default };

//# sourceMappingURL=Paragraph.module.js.map